import { Injectable, signal } from '@angular/core';

/**
 * AM-78: the save state (SM-SAVE) shows in the expanded workbook's header, beside the title, not in a
 * row of its own. The header and the editor are siblings, so the editor publishes its state here
 * while it is bound to a workbook, and clears it when it goes.
 */
@Injectable({ providedIn: 'root' })
export class EditorSaveStatus {
  public readonly current = signal<{ readonly state: string; readonly label: string } | null>(null);
  /** How many sheets the open workbook has now, for the header's "<n> sheets" (SBUX-1036); null until it has loaded. */
  public readonly sheets = signal<number | null>(null);
}
